export default __webpack_public_path__ + "static/media/video-square.db26a04d.jpg";